import type { Locale, TranslationNamespace } from "./store/types";

import { commonEn } from "./locales/en/Common";
import { commonEs } from "./locales/es/Common";
import { controlPanelEn } from "./locales/en/ControlPanel";
import { controlPanelEs } from "./locales/es/ControlPanel";
import { microspaceAnalysisEn } from "./locales/en/MicrospaceAnalysis";
import { microspaceAnalysisEs } from "./locales/es/MicrospaceAnalysis";
import { assortmentSimulationEn } from "./locales/en/AssortmentSimulation";
import { assortmentSimulationEs } from "./locales/es/AssortmentSimulation";
import { spacePlanningEn } from "./locales/en/SpacePlanning";
import { spacePlanningEs } from "./locales/es/SpacePlanning";
import { planogramsEn } from "./locales/en/Planograms";
import { planogramsEs } from "./locales/es/Planograms";
import { assortmentSimulationDetailEn } from "./locales/en/AssortmentSimulationDetail";
import { assortmentSimulationDetailEs } from "./locales/es/AssortmentSimulationDetail";
import { settingsEn } from "./locales/en/Settings";
import { settingsEs } from "./locales/es/Settings";
import { planogramDeliveryEn } from "./locales/en/PlanogramDelivery";
import { planogramDeliveryEs } from "./locales/es/PlanogramDelivery";
import { cdtStudioEn } from "./locales/en/CdtStudio";
import { cdtStudioEs } from "./locales/es/CdtStudio";
import { distributionPlannerEn } from "./locales/en/DistributionPlanner";
import { distributionPlannerEs } from "./locales/es/DistributionPlanner";
import { pogAgentEn } from "./locales/en/PogAgent";
import { pogAgentEs } from "./locales/es/PogAgent";

type TranslationDictionary = Record<string, unknown>;

type RegistryMap = Record<Locale, Record<TranslationNamespace, TranslationDictionary>>;

export const translationRegistry: RegistryMap = {
  en: {
    common: commonEn,
    controlPanel: controlPanelEn,
    microspaceAnalysis: microspaceAnalysisEn,
    assortmentSimulation: assortmentSimulationEn,
    spacePlanning: spacePlanningEn,
    planograms: planogramsEn,
    assortmentSimulationDetail: assortmentSimulationDetailEn,
    settings: settingsEn,
    planogramDelivery: planogramDeliveryEn,
    cdtStudio: cdtStudioEn,
    distributionPlanner: distributionPlannerEn,
    pogAgent: pogAgentEn,
  },
  es: {
    common: commonEs,
    controlPanel: controlPanelEs,
    microspaceAnalysis: microspaceAnalysisEs,
    assortmentSimulation: assortmentSimulationEs,
    spacePlanning: spacePlanningEs,
    planograms: planogramsEs,
    assortmentSimulationDetail: assortmentSimulationDetailEs,
    settings: settingsEs,
    planogramDelivery: planogramDeliveryEs,
    cdtStudio: cdtStudioEs,
    distributionPlanner: distributionPlannerEs,
    pogAgent: pogAgentEs,
  },
};
